export const getRedirectPath = () => {
  // 1. Check URL query parameters (?redirect= or ?returnUrl=)
  try {
    const params = new URLSearchParams(window.location.search);
    const redirectParam = params.get("redirect") || params.get("returnUrl");
    if (redirectParam && redirectParam.startsWith("/")) {
      return redirectParam;
    }
  } catch (e) {
    // Ignore URL parsing issues
  }

  // 2. Check sessionStorage (set by ProtectedRoute)
  try {
    const sessionStored = sessionStorage.getItem("authRedirect");
    if (sessionStored && sessionStored.startsWith("/")) {
      return sessionStored;
    }
  } catch (e) {
    // Ignore
  }

  // 3. Check localStorage
  try {
    const stored = localStorage.getItem("authRedirectPath");
    if (stored && stored.startsWith("/")) {
      return stored;
    }
  } catch (e) {
    // Ignore
  }

  return "/ballots";
};

export const storeRedirectPath = (path) => {
  try {
    if (path && typeof path === "string" && path.startsWith("/")) {
      localStorage.setItem("authRedirectPath", path);
      sessionStorage.setItem("authRedirect", path);
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const redirectParam = params.get("redirect") || params.get("returnUrl");
    if (redirectParam && redirectParam.startsWith("/")) {
      localStorage.setItem("authRedirectPath", redirectParam);
      sessionStorage.setItem("authRedirect", redirectParam);
    }
  } catch (e) {
    // Ignore
  }
};

export const clearRedirectPath = () => {
  try {
    localStorage.removeItem("authRedirectPath");
    sessionStorage.removeItem("authRedirect");
  } catch (e) {
    // Ignore
  }
};
